{
  "main": "Haupt",
  "my_library": "Meine Bibliothek",
  "node_names": {
    "Folder": "Ordner",
    "PersonalMappingLibrary": "Mein Arbeitsbereich",
    "MappingLibrary": "Team-Arbeitsbereich",
    "Map": "Planen",
    "Layer": "Ebene",
    "MapObject": "Objekt",
    "Schedule": "Zeitplan",
    "ScheduleVersion": "Zeitplan"
  },
  "static_library_names": {
    "recently_viewed": "Kürzlich angesehen",
    "favourites": "Favoriten"
  },
  "static_library_empty": {
    "recently_viewed": "Tarife, die Sie kürzlich geöffnet haben, werden hier angezeigt",
    "favourites": "Pläne und Ordner, die Sie als Favoriten ausgewählt haben, werden hier angezeigt, sodass Sie problemlos darauf zugreifen können"
  },
  "static_library_empty_button": {
    "recently_viewed": "Fangen Sie mit Ihrem ersten Plan an",
    "favourites": "Stöbern Sie in den Projektplänen"
  },
  "node_content": {
    "last_activity": "Letzte Aktivität {{ latestActivityDate }}",
    "created": "{{ createdAt }} erstellt",
    "last_viewed": "Zuletzt angesehen {{ viewedAt }}"
  },
  "create_node": {
    "saveInFolder": "Im Ordner speichern",
    "title": "{{ nodeName }} erstellen",
    "fieldLabel": "{{ nodeName }} Name",
    "creating": "{{ nodeName }} wird erstellt...",
    "maxInputChars": "Der Name darf nicht länger als 500 Zeichen sein"
  },
  "permissions": "Bearbeiten Sie {{ nodeName }} Berechtigungen",
  "update_node": {
    "title": "Benennen Sie {{ nodeName }} um",
    "description": "Dieser {{ nodeName }} wird für alle aktualisiert.",
    "updating": "{{ nodeName }} wird umbenannt..."
  },
  "delete_node": {
    "singular_title": "Löschen Sie einen {{ nodeType }}",
    "singular_description": "Wenn Sie diesen {{ nodeType }} löschen, wird auch der gesamte Inhalt gelöscht.",
    "singular_confirm_button": "Löschen Sie {{ nodeType }}",
    "multi_title": "{{ count }} Artikel löschen",
    "multi_description": "Durch das Löschen dieser Elemente wird auch der gesamte Inhalt gelöscht.",
    "multi_confirm_button": "Elemente löschen"
  },
  "overflow": {
    "description": "Klicken Sie hier, um die Optionen für {{ nodeName }} zu öffnen",
    "rename": "Benennen Sie {{ nodeName }} um",
    "delete": "{{ nodeName }} löschen",
    "permissions": "{{ nodeName }} Berechtigungen ändern"
  },
  "empty_node": "{{ nodeName }} ist leer",
  "folder_browser_view": {
    "while_in": {
      "list": "Als Kacheln anzeigen",
      "tile": "Als Liste anzeigen"
    }
  },
  "sort": {
    "folder_first_asc": "Ordner zuerst (A-Z)",
    "name_asc": "Name (A-Z)"
  },
  "saveLocation": {
    "visibleYou": "Nur für dich sichtbar",
    "visibleOtherTeamMembers": "Sichtbar für andere Teammitglieder",
    "visibleWholeProject": "Für jeden sichtbar",
    "teamMembers": "Teammitglieder"
  },
  "hints": {
    "PersonalMappingLibrary": {
      "title": "Mein Workspace",
      "first_paragraph": "Pläne, die du hier erstellst, stehen nur dir zur Verfügung. \nVerwenden Sie die Schaltfläche „Plan erstellen“, um Ihren ersten Plan zu erstellen.",
      "second_paragraph": "Wenn du bereit bist, Pläne mit deinem Team zu teilen, kannst du den „Team-Arbeitsbereich“ verwenden."
    },
    "MappingLibrary": {
      "title": "Team-Arbeitsbereich",
      "first_paragraph": "Die hier erstellten Pläne werden von deinem Team gemeinsam genutzt. Verwenden Sie diesen Bereich, wenn Sie mit anderen Teammitgliedern zusammenarbeiten.",
      "second_paragraph": "Sie können Ihre Pläne auch in Ordnern organisieren, z. B. für verschiedene Abteilungen."
    },
    "Map": {
      "title": "Es wurden noch keine Ebenen hinzugefügt",
      "first_paragraph": "Erstellen Sie zunächst eine Ebene, um Ihrem Plan Objekte hinzuzufügen."
    },
    "Folder": {
      "title": "Der Ordner ist leer",
      "first_paragraph": "Klicken Sie oben auf die Schaltfläche „Plan erstellen“, um hier einen Plan hinzuzufügen."
    },
    "ScheduleVersion": {
      "title": "{{ type }}",
      "first_paragraph": "Erstellen Sie einen {{ type }} um mit der Planung von Veranstaltungen zu beginnen."
    }
  },
  "hints_static_libraries": {
    "recently_viewed": {
      "title": "Kürzlich angesehen",
      "first_paragraph": "Ihre zuletzt angesehenen Tarife werden hier angezeigt."
    },
    "favourites": {
      "title": "Favoriten",
      "first_paragraph": "Ihre bevorzugten Tarife und Ordner werden hier angezeigt."
    }
  },
  "remove_node": {
    "singular_title": "Entferne einen {{ nodeType }}",
    "singular_description": "Wenn Sie diesen {{ nodeType }} entfernen, wird er aus dem Plan entfernt, ist aber weiterhin im ursprünglichen Plan enthalten",
    "singular_confirm_button": "{{ nodeType }} entfernen",
    "multi_title": "{{ count }} Artikel löschen",
    "multi_description": "Durch das Löschen dieser Elemente wird auch der gesamte Inhalt gelöscht.\n \nImportierte/verknüpfte Ebenen werden aus dem Plan entfernt, sind aber weiterhin im ursprünglichen Plan vorhanden.",
    "multi_confirm_button": "Artikel löschen"
  },
  "cannot_drop_folder_into_its_sub_folder": "Ein Ordner kann nicht in einen eigenen Unterordner verschoben werden",
  "drag_and_drop": {
    "moving_multiple_items": "{{ count }} Artikel werden verschoben..."
  },
  "create_map_location": "Im Ordner speichern"
}